export default __webpack_public_path__ + "static/media/art_wheel_bg.2a82681f.svg";